import React from "react";
import StfExamResult from "../../components/StaffTabs/StaffExamResult/StfExamResult"

const SendFeedback = () => {
  return (
    <div>
      
      <StfExamResult/>
    </div>
  );
};

export default SendFeedback;
